import { DISMISS_NOTIFICATION, TOGGLE_NOTIFICATION } from '../../../ActionsConst';

/** notification active/inactive on the page - page dependant */
export const toggleNotification = (isActive) => ({
  type: TOGGLE_NOTIFICATION,
  isActive,
});

/** user dismissed the notification */
export const dismissNotification = () => ({
  type: DISMISS_NOTIFICATION,
});
